import React from 'react'
import { foodPackageVS } from 'services/validations/catalog/packages/foodPackage'
import ProductPackageBaseFormProvider from '../ProductPackageBaseFormProvider'
import { FoodPresetAdditionalFields } from './FoodPresetAdditionalFields'

const FoodPackageForm: React.FC = () => (
  <ProductPackageBaseFormProvider
    entity="foods"
    validationSchema={foodPackageVS}
    presetInputFields={<FoodPresetAdditionalFields />}
  />
)

export default FoodPackageForm
